<template>
  <div id="app">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-cascader
          size="small"
          placeholder="资讯类型"
          clearable
          v-model="typeId"
          :options="typeList"
          :props="{ children: 'childList', value: 'id', label: 'typeName' }"
          @change="handleChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="titleName"
          placeholder="请输入标题名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="queryArticleList"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button @click="addInfo" size="small" type="primary"
          >添加内容</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      border
      :header-cell-style="{ background: '#f5f5f5',height: '48px' }"
      :row-style="{ height: '48px' }"
      :data="dynamicList"
      stripe
      style="width: 100%;margin-bottom:20px"
    >
      <el-table-column
        align="center"
        prop="typeName"
        label="资讯类型"
        width="180"
      >
      </el-table-column>
      <el-table-column align="center" prop="articleTitle" label="标题">
      </el-table-column>
      <el-table-column align="center" label="状态" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.articleStatus == 0 ? "存草稿" : "发布" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="置顶" width="180">
        <template slot-scope="scope">
          <el-switch
            @change="topChange(scope.row.id, scope.row.isTop)"
            v-model="scope.row.isTop"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首页展示" width="180">
        <template slot-scope="scope">
          <el-switch
            @change="homeChange(scope.row.id, scope.row.isHome)"
            v-model="scope.row.isHome"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="发布时间"
        width="180"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="editDynamic(scope.row.id)"
            >编辑</el-button
          >
          <el-button style="color:#ff5151" type="text" @click="deleteDynamic(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="totalCount"
      hide-on-single-page
    ></el-pagination>
    <el-dialog title="资讯" width="950px" :visible.sync="dialogFormVisible">
      <el-form ref="refDig" :model="modelForm" :rules="rules">
        <el-form-item label="资讯类型" :label-width="formLabelWidth">
          <el-select
            @change="typeCag"
            size="small"
            v-model="typeId1"
            placeholder="请选择资讯类型"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            v-if="typeListC !== null"
            v-model="typeId2"
            placeholder="请选择资讯类型"
          >
            <el-option
              v-for="item in typeListC"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" :label-width="formLabelWidth" prop="titleC">
          <el-input
            size="small"
            style="width: 400px"
            v-model="modelForm.titleC"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            size="small"
            type="textarea"
            :rows="2"
            style="width: 400px"
            v-model="description"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面" :label-width="formLabelWidth" prop="imgUrl">
          <el-upload
            ref="upload"
            class="cover-uploader"
            :headers="headers"
            :data="datas"
            :action="uploadurl"
            :on-success="uploadImageSuccess"
            accept="image/*"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <div
              v-loading="loading"
              element-loading-text="上传中..."
              element-loading-background="rgba(0, 0, 0, 0.7)"
            >
              <img v-if="imgUrl" :src="imgUrl" class="cover" />
              <i v-else class="el-icon-picture cover-uploader-icon"></i>
            </div>
          </el-upload>
          <span class="cover-text">图片建议尺寸：320*200</span>
        </el-form-item>
        <el-form-item
          class="content"
          label="内容"
          :label-width="formLabelWidth"
          prop="content"
        >
          <el-input
            size="small"
            v-show="false"
            style="width: 400px"
            v-model="modelForm.content"
            autocomplete="off"
          ></el-input>
          <quill-editor
            v-model="modelForm.content"
            ref="myQuillEditor"
            :options="editorOption"
            class="infoquill"
            style="height: 300px; margin-top: 13px"
          >
          </quill-editor>
          <!-- @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)" -->
        </el-form-item>
        <el-form-item
          style="margin-top: 115px"
          label="附件"
          :label-width="formLabelWidth"
        >
          <el-upload
            :headers="headers"
            :action="uploadurl"
            :data="datas"
            :accept="filetype"
            :on-success="fileSuccess"
            :show-file-list="true"
            :file-list="fileList"
          >
            <el-button type="success" size="small" icon="el-icon-upload"
              >上传附件</el-button
            >
          </el-upload>
          <el-row
            class="upload-list"
            v-for="(item, index) in resultList"
            :key="index"
          >
            <el-col :span="16" style="padding-left: 20px">{{
              item.fileName
            }}</el-col>
            <el-col :span="4">{{ item.time }}</el-col>
            <el-col :span="4">
              <span class="upload-btn-del" @click="fileRemove(index)"
                >删除</span
              >
              <a
                download
                v-if="articleId == -1"
                :href="item.urls"
                class="upload-btn-down"
                >下载</a
              >
              <a
                download
                v-else
                :href="item.serverHttp + item.fileUrl"
                class="upload-btn-down"
                >下载</a
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="置顶" :label-width="formLabelWidth">
          <el-switch
            v-model="placed"
            active-color="#13ce66"
            inactive-color="#E9E9E9"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否推荐首页" :label-width="formLabelWidth">
          <el-switch
            v-model="isHome"
            active-color="#13ce66"
            inactive-color="#E9E9E9"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否群发公众号" :label-width="formLabelWidth">
          <el-switch
            v-model="isPush"
            :disabled="hjui"
            active-color="#13ce66"
            inactive-color="#E9E9E9"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="quxiao">取 消</el-button>
        <el-button size="small" type="success" @click="saveArticleInfo(0)"
          >存草稿</el-button
        >
        <el-button size="small" type="primary" @click="saveArticleInfo(1)"
          >发 布</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      typeId: [],
      groupId: localStorage.getItem("groupId"),
      // groupId: 5,
      name: localStorage.getItem("name"),
      nameId: localStorage.getItem("id"),
      titleName: "",
      editorOption: {},
      formLabelWidth: "120px",
      dialogFormVisible: false,
      headers: {
        token: localStorage.getItem("token"),
      },
      modelForm: {
        contents: "请输入内容",
        titleC: "", //标题
      },
      uploadurl: homeApi.urls + "/file/oss-upload?bucketId=1", //上传图片地址
      datas: {
        bucketId: 1,
      }, //限制上传数量
      loading: false,
      imgUrl: "",
      imgName: "", //图片文件名称
      filetype: "",
      resultList: [], // 最终文件列表
      fileList: [], // 文件列表
      articleId: -1,
      rules: {
        titleC: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "change" }],
      },
      typeList: [],
      typeListC: null,
      typeId1: "",
      typeId2: "",
      description: "", //描述
      placed: false, //置顶
      isHome: false, //首页
      isPush:false,
      dynamic: {
        curPage: 1,
        pageSize: 10,
        schoolId: localStorage.getItem("groupId"),
        // schoolId: 5,
        articleBelong: 2,
      },
      dynamicList: [],
      totalCount: 0,
      articleInfo: {},
      hjui:false
    };
  },
  created() {
    this.queryArticleList();
    this.queryTypeList();
  },
  methods: {
    addInfo() {
      this.hjui=false
      this.dialogFormVisible = true;
    },
    //开始上传前
    beforeAvatarUpload(file) {
      //上传加载中
      this.loading = true;
      //判断是否为图片格式
      const isImage = file.type.indexOf("image");
      //上传大小
      const fileSize = 100 * 1024 * 1000;
      if (isImage < 0) {
        // this.$toast.center("只能上传图片格式");
      }
      if (file.size > fileSize) {
        _this.$message.error("图片大小不能超过100M");
      }
      return isImage;
    },

    handleChange(value) {
      // console.log(value);
      // console.log(this.typeId);
      this.queryArticleList();
    },
    //图片上传成功
    uploadImageSuccess(res, file) {
      //上传成功
      this.loading = false;
      //上传成功返回数据
      if (res.code == ERR_OK) {
        let data = res.data[0];
        this.imgUrl = data.url;
        this.imgName = data.fileName;
      }
      //显示图片
      this.fileChange(file);
    },
    //重新上传图片
    fileChange(file) {
      this.$refs.upload.clearFiles(); //清除文件对象
      this.thumb = URL.createObjectURL(file.raw);
    },
    //文件上传成功
    fileSuccess(file, data, list) {
      //清除文件列表
      this.fileList = [];
      //自定义文件列表
      let lists = file.data[0];
      let dates = {};
      dates.urls = lists.url;
      dates.url = lists.fileName;
      dates.fileNameSuffix = lists.fileNameSuffix;
      dates.fileName = lists.originalFilename;
      dates.size = lists.size;
      dates.md5 = lists.md5;
      dates.time = this.dateFormat(file.times, "YYYY-MM-DD");
      this.resultList.push(dates);
    },
    //时间戳转日期格式
    dateFormat(data, keyStr) {
      return moment(new Date(data)).format(keyStr);
    },
    //文件删除
    fileRemove(i) {
      this.resultList.splice(i, 1);
    },
    // 根据集团校ID查询动态类型
    queryTypeList() {
      homeApi
        .queryTypeList({
          groupId: this.groupId,
        })
        .then((res) => {
          let list = res.data.data;
          list.forEach((item) => {
            if (item.childList !== null) {
              item.childList.forEach((items) => {
                delete items.childList;
              });
            }
          });
          this.typeList = res.data.data;
          this.typeListC = this.typeList[0].childList;
        });
    },
    // 动态类型变化
    typeCag(e) {
      this.typeList.forEach((item) => {
        if (item.id == e) {
          this.typeListC = item.childList;
        }
      });
    },
    // 动态保存
    saveArticleInfo(status) {
      this.$refs.refDig.validate((valid) => {
        if (valid) {
          this.tijiao(status);
        } else {
          return false;
        }
      });
    },
    // 提交API
    tijiao(status) {
      let fileReslistList = [];
      // 上传文件处理
      if (this.resultList.length !== 0) {
        this.resultList.forEach((item) => {
          let list = {};
          list.fileFormat = item.fileNameSuffix;
          list.fileName = item.fileName;
          list.fileUrl = item.url;
          list.md5 = item.md5;
          list.fileSize = item.size;
          fileReslistList.push(list);
        });
      }

      let params = {
        articleBelong: 2,
        articleContent: this.modelForm.content,
        articleDescription: this.description,
        articleStatus: status,
        articleTitle: this.modelForm.titleC,
        fileReslists: fileReslistList,
        imgUrl: this.imgName,
        isHome: 0,
        isPush:0,
        isTop: 0,
        schoolId: this.groupId,
        creatorId: this.nameId,
        creatorName: this.name,
      };
      if (this.articleId !== -1) {
        params.id = this.articleId;
      }
      if (this.placed) {
        params.isTop = 1;
      }
      if (this.isHome) {
        params.isHome = 1;
      }
      if(this.isPush){
        params.isPush=1
      }
      if (this.typeListC == null) {
        params.typeId = this.typeId1;
        // params.typeName
        this.typeList.forEach((item) => {
          if (this.typeId1 == item.id) {
            params.typeName = item.typeName;
          }
        });
      } else {
        params.typeId = this.typeId2;
        this.typeListC.forEach((item) => {
          if (this.typeId2 == item.id) {
            params.typeName = item.typeName;
          }
        });
      }
      if (params.typeId == "") {
        this.$message.error("请选择资讯类型");
        return false;
      }
      homeApi.saveArticleInfo(params).then((res) => {
        let title = "发布成功";
        if (status == 0) {
          title = "存草稿成功";
        }
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: title,
          });
        }
        this.queryArticleList();
        this.dialogFormVisible = false;
        this.clear();
      });
    },
    quxiao() {
      this.dialogFormVisible = false;
      this.clear();
    },
    // 清除缓存
    clear() {
      this.modelForm.content = "请输入内容";
      this.description = "";
      this.modelForm.titleC = "";
      this.imgName = "";
      this.imgUrl = "";
      this.typeId1 = "";
      this.typeId2 = "";
      this.placed = false;
      this.isHome = false;
      this.isPush = false;
      this.resultList = [];
      this.fileList = [];
      this.articleId = -1;
    },
    // 动态资源删除
    deleteDynamic(id) {
      homeApi
        .deleteDynamic({
          id: id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.queryArticleList();
          }
        });
    },
    // 查询动态列表
    queryArticleList() {
      let params = {
        ...this.dynamic,
      };
      if (this.typeId.length > 0) {
        params.typeId = this.typeId[this.typeId.length - 1];
      }
      if (this.titleName) {
        params.articleTitle = this.titleName;
      }
      homeApi.queryArticleList(params).then((res) => {
        let list = res.data.data.dataList;
        list.forEach((item) => {
          item.isHome = item.isHome == 0 ? false : true;
          item.isPush = item.isPush == 0 ? false : true;
          item.isTop = item.isTop == 0 ? false : true;
        });
        this.dynamicList = list;
        this.totalCount = res.data.data.totalCount;
      });
    },
    // 查询动态详情
    async queryArticleInfo(id) {
      let res = await homeApi.queryArticleInfo({ articleId: id });
      return res.data.data;
    },
    // 置顶变化
    async topChange(id, flag) {
      let res = await this.queryArticleInfo(id);
      res.isTop = flag ? 1 : 0;
      this.topHome(res);
    },
    // 首页变换
    async homeChange(id, flag) {
      let res = await this.queryArticleInfo(id);
      res.isHome = flag ? 1 : 0
      this.topHome(res);
    },
    // 置顶，推荐变化
    topHome(res) {
      homeApi
        .saveArticleInfo({
          ...res,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryArticleList();
          }
        });
    },
    // 编辑
    async editDynamic(id) {
      this.hjui=true
      let res = await this.queryArticleInfo(id);
      this.dialogFormVisible = true;
      this.modelForm.content = res.articleContent;
      this.description = res.articleDescription;
      this.modelForm.titleC = res.articleTitle;
      this.imgUrl = res.serverHttp + res.imgUrl;
      this.imgName = res.imgUrl;
      this.resultList = res.fileReslists || [];
      console.log(this.resultList);
      this.placed = res.isTop == 0 ? false : true;
      this.isHome = res.isHome == 0 ? false : true;
      this.isPush = res.isPush == 0 ? false : true;
      this.articleId = res.id;
      //  this.typeId1 = "";
      // this.typeId2 = "";
      this.typeList.forEach((item) => {
        if (item.id == res.typeId) {
          this.typeId1 = item.id;
        } else {
          if (item.childList !== null) {
            item.childList.forEach((items) => {
              if (items.id == res.typeId) {
                this.typeId1 = item.id;
                this.typeId2 = items.id;
              }
            });
          }
        }
      });
    },
    // 页码变化
    currentChange(e) {
      this.dynamic = e;
      this.queryArticleList();
    },
    // download(src, name) {
    //   // 创建隐藏的可下载链接
    //   let eleLink = document.createElement("a");
    //   eleLink.href = src;
    //   eleLink.download = name;
    //   eleLink.style.display = "none";
    //   eleLink.href = src;
    //   document.body.appendChild(eleLink);
    //   eleLink.click();
    //   document.body.removeChild(eleLink);
    // },
  },
};
</script>
<style scoped>
.cover-text {
  color: #8c939d;
  position: absolute;
  bottom: -25px;
  height: 25px;
  line-height: 25px;
}
.cover-uploader .el-upload:hover {
  border-color: #409eff;
}
.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px solid;
  border-radius: 4px;
  width: 320px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.cover {
  width: 320px;
  height: 200px;
  display: block;
}
.cover-text {
  color: #8c939d;
  position: absolute;
  bottom: -25px;
  height: 25px;
  line-height: 25px;
}
.infoquill .ql-clipboard {
  height: 230px;
}
.upload-list {
  width: 800px;
  background: #ecf5ff;
  margin-top: 10px;
  border-radius: 5px;
}
.upload-list span,
.upload-list a {
  padding: 3px 10px;
}
.upload-list-left {
  /* width: ~'calc(100% - 390px)'; */
  width: 390px;
}
.upload-list-right {
  width: 130px;
}
.upload-btn-del {
  color: #fff;
  cursor: pointer;
  background: #f56c6c;
  border-radius: 3px;
  margin: 0 5px;
}
.upload-btn-down {
  color: #fff;
  cursor: pointer;
  background: #409eff;
  border-radius: 3px;
  margin: 0 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/informa/ment.vue